<template>
  <v-card
    :class="[
      'lesson-card-wrap',
      lessonClassNameToKebab,
      { active: isSelected }
    ]"
    :data-id="'lsncrd' + lesson.id"
  >
    <v-dialog v-model="dialog" absolute content-class="dialog-file">
      <v-toolbar class="primary" dark>
        <v-spacer />
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn text @click="dialog = false">
            <v-icon>close</v-icon>
            Close
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <iframe :src="url" />
    </v-dialog>

    <v-img :src="lesson.thumbnail_image" height="200px">
      <v-row no-gutters align="center" class="lesson-image">
        <h5 class="lesson-title">
          {{ lesson.name ? lesson.name : (lessonTerm | capitalize) + ' Name' }}
        </h5>
      </v-row>
    </v-img>
    <v-card-text primary-title class="noselect">
      <div class="lesson-desc-wrap">
        <p>
          {{ lesson.description }}
        </p>
      </div>
      <v-row justify="center" dense class="mt-3">
        <v-col cols="6" v-if="teacherList && lesson.lesson_plan_url">
          <v-btn
            block
            outlined
            color="primary"
            @click="showFrame(lesson.name, lesson.lesson_plan_url)"
          >
            Teacher Guide
          </v-btn>
        </v-col>
        <v-col cols="6" v-if="teacherList && lesson.activity_sheet_url">
          <v-btn
            block
            outlined
            color="primary"
            @click="showFrame(lesson.name, lesson.activity_sheet_url)"
          >
            Activity Sheet
          </v-btn>
        </v-col>
        <v-col
          cols="6"
          v-if="
            (clientList || teacherList || parentList) &&
              lessonObject.lesson_slides.length
          "
        >
          <v-btn block outlined color="primary" @click="startLesson">
            Try {{ lessonTerm }}
          </v-btn>
        </v-col>
        <v-col
          cols="12"
          v-if="
            (studentList || individualList) && lessonObject.lesson_slides.length
          "
        >
          <v-btn
            block
            outlined
            color="primary"
            class="button_google_tag_manager"
            data-category="user"
            data-action="click"
            :data-label="`started lesson : ${lesson.name}`"
            @click="startLesson"
          >
            {{ lessonTypeAction }}
          </v-btn>
        </v-col>
        <v-col
          cols="6"
          v-if="
            !teacherList &&
              !studentList &&
              !clientList &&
              !individualList &&
              !parentList
          "
        >
          <v-btn
            block
            dark
            :color="isSelected ? 'red darken-1' : 'light-green accent-4'"
            @click="selectLesson()"
          >
            {{ isSelected ? 'Deselect' : 'Select' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- And if class > 1 -->
    <v-expansion-panel
      v-if="showClassList && totalLinkedClasses"
      class="classes-expand"
    >
      <v-expansion-panel-content>
        <template v-slot:header>
          <div>
            {{ totalLinkedClasses }}
            {{ totalLinkedClasses > 1 ? 'classes are' : 'class is' }}
            currently doing this {{ lessonTerm }}
          </div>
        </template>
        <v-card color="py-2 px-1">
          <v-chip
            class="mr-2"
            label
            outlined
            disabled
            color="grey"
            v-for="customClassName in lesson.linked_classes"
            :key="customClassName"
          >
            {{ customClassName }}
          </v-chip>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <section
      v-else-if="showClassList && totalLinkedClasses == 0"
      class="classes-noexpand"
    >
      <div>No class has selected this {{ lessonTerm }}</div>
    </section>
  </v-card>
</template>

<script>
import _ from 'lodash'
import Lesson from '@/modules/lesson/models/Lesson'
import { mapState } from 'vuex'

export default {
  name: 'LessonCard',
  props: {
    userLessons: {
      type: Array,
      required: false
    },
    teacherList: {
      type: Boolean,
      default: false
    },
    studentList: {
      type: Boolean,
      default: false
    },
    parentList: {
      type: Boolean,
      default: false
    },
    individualList: {
      type: Boolean,
      default: false
    },
    clientList: {
      type: Boolean,
      default: false
    },
    showClassList: {
      type: Boolean,
      default: false
    },
    lesson: {
      type: Object,
      required: true
    },
    initSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      url: '',
      isSelected: this.initSelected,
      id: this.lesson.id
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    lessonTypeAction() {
      let found = false
      for (const userLessonIndex in this.userLessons) {
        if (this.lesson.id === this.userLessons[userLessonIndex].lesson_id)
          found = true
      }
      return found === true
        ? `Resume ${this.capitalizeFirstLetter(this.lessonTerm)}`
        : `Start ${this.capitalizeFirstLetter(this.lessonTerm)}`
    },
    activeLessons() {
      return Lesson.all()
    },
    totalLinkedClasses() {
      if (!this.lesson.linked_classes) return 0
      return this.lesson.linked_classes.length
    },
    lessonClassNameToKebab() {
      return _.kebabCase(this.lesson.name)
    },
    lessonObject() {
      return Lesson.find(this.lesson.id)
    }
  },
  methods: {
    startLesson() {
      this.$emit('startClassLesson', this.lesson)
    },
    selectLesson() {
      this.isSelected = !this.isSelected
      this.$emit('toggleLessonSelect', this.isSelected, this.lesson.id)
    },
    showFrame(name, url) {
      this.dialog = true
      this.url = url
    }
  }
}
</script>

<style lang="scss">
.dialog-file.v-dialog--active {
  width: 99vw;
  height: 99vh;
  overflow: hidden;
  iframe {
    width: 100%;
    height: 100%;
  }
}
.lesson-card-wrap {
  border: grey solid 0px;
  overflow: hidden;

  button {
    width: 100%;
  }

  .lesson-image {
    height: 100%;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;

    .lesson-title {
      text-align: center;
      color: white;
      text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
      font-size: 30px;
      display: block;
      line-height: 35px;
      padding: 10px;
    }
  }
  .lesson-desc-wrap {
    overflow-y: auto;
    height: 80px;
  }
  &.active {
    border: #64dd17 solid 1px;
    box-shadow: 0px 3px 5px -1px rgba(76, 175, 80, 0.2),
      0px 6px 10px 0px rgba(76, 175, 80, 0.14),
      0px 1px 18px 0px rgba(76, 175, 80, 0.12);
  }
  .classes-noexpand {
    background-color: var(--v-primary-base)-light;

    > div {
      line-height: 50px;
      padding: 0 24px;
    }
  }
  .classes-expand {
    .v-expansion-panel__header {
      background-color: var(--v-primary-base)-light;
    }

    ul {
      list-style-type: none;
      li {
        line-height: 50px;
        border-bottom: 1px solid #ccc;
        &:last-of-type {
          border: none;
        }
      }
    }
  }
}
</style>
